import request from '@/utils/request'


/**
 * 充值记录列表
 * @param query
 */
export function fetchList(query) {
    return request({
        url: '/api/recharge/list',
        method: 'post',
        data: query || {}
    })
}



/**
 * 删除充值记录
 * @param param
 */
export function remove(param) {
    return request({
        url: '/api/recharge/delete/' + param,
        method: 'get'
    })
}

/**
 * 获取单个试卷信息
 * @param param
 */
export function get(param) {
    return request({
        url: '/api/recharge/get/' + param,
        method: 'get'
    })
}

/**
 * 保存充值记录
 * @param param
 */
export function save(param) {
    return request({
        url: '/api/recharge/save',
        method: 'post',
        data: param || {}
    })
}

/**
 * 修改试卷
 * @param param
 */
export function update(param) {
    return request({
        url: '/api/recharge/update',
        method: 'post',
        data: param
    })
}


